import {
  END_CREATING_RECORDS,
  CANCEL_UPDATE_RECORD,
  SET_IMPORT_SUMMARY,
  SET_RECORDS,
  START_RETRIEVE_RECORDS,
  START_UPDATE_RECORD,
  TOGGLE_SKIP_RECORD,
  UPDATE_EDITING_RECORD,
  UPDATE_RECORD_PAGE,
  UPDATE_RECORD,
  TOGGLE_SKIP_ALL_RECORDS
} from '../actions/run_records';

const defaultState = {
  creatingRunRecords: true,
  headers: [],
  loadingRecords: false,
  editingRecord: {
    id: null
  },
  meta: {
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    totalCount: 0,
    totalErrors: 0
  },
  recordPage: 1,
  records: {},
  recordIds: [],
  importSummary: {
    created: 0,
    updated: 0,
    failed: 0,
    skipped: 0
  }
};

export default function(state = defaultState, action) {
  switch (action.type) {
  case END_CREATING_RECORDS: {
    return {
      ...state,
      creatingRunRecords: false
    };
  }
  case CANCEL_UPDATE_RECORD: {
    return {
      ...state,
      editingRecord: {
        id: null
      },
      editRow: false
    };
  }
  case SET_RECORDS: {
    return {
      ...state,
      records: { ...action.records },
      recordIds: [...action.recordIds],
      meta: action.meta,
      headers: action.headers,
      importSummary: action.importSummary,
      loadingRecords: false
    };
  }
  case SET_IMPORT_SUMMARY: {
    return {
      ...state,
      importSummary: action.importSummary,
      loadingRecords: false
    };
  }
  case START_RETRIEVE_RECORDS: {
    return {
      ...state,
      loadingRecords: true
    };
  }
  case START_UPDATE_RECORD: {
    return {
      ...state,
      editingRecord: { ...action.record },
      editRow: action.editRow
    };
  }
  case TOGGLE_SKIP_ALL_RECORDS: {
    const records = state.records;

    Object.keys(records).forEach((id) => {
      const record = { ...records[id] };
      record.skip = action.skip;
      records[id] = record;
    });

    return {
      ...state,
      records: { ...records },
      meta: {
        ...state.meta,
        allRecordsSelected: !action.skip
      }
    };
  }
  case TOGGLE_SKIP_RECORD: {
    const records = state.records;
    const record = { ...records[action.recordId] };
    record.skip = !record.skip;
    records[action.recordId] = record;

    return {
      ...state,
      records: { ...records },
      meta: {
        ...state.meta,
        allRecordsSelected: state.meta.allRecordsSelected && !record.skip
      }
    };
  }
  case UPDATE_EDITING_RECORD: {
    return { ...state, editingRecord: { ...action.record } };
  }
  case UPDATE_RECORD: {
    const records = state.records;
    records[action.record.id] = { ...action.record };

    return {
      ...state,
      records: { ...records }
    };
  }
  case UPDATE_RECORD_PAGE: {
    return {
      ...state,
      recordPage: action.page
    };
  }
  default:
    return { ...state };
  }
}
